import React from 'react';
import { Alert, Tooltip, Typography } from '@mui/material';
import { CurrencyDollarIcon } from '@heroicons/react/24/solid';
import { ActivityFeedRow } from 'src/@types/reports';
import { fDateTime } from 'src/utils/formatTime';

type PaidInteractionAlertProps = {
  activityFeedRow: ActivityFeedRow;
};

const PaidInteractionAlert = ({ activityFeedRow }: PaidInteractionAlertProps) => {
  if (!activityFeedRow.is_paid_interaction) {
    return <></>;
  }

  let tooltipMsg = '';
  let severity: 'info' | 'error' | 'warning' | 'success' = 'info';
  let alertMsg: string | React.ReactElement = '';
  const icon = <CurrencyDollarIcon width={20} height={20} />;

  if (activityFeedRow.paid_interaction_payment_at) {
    tooltipMsg =
      'Paid Interaction Approved ' +
      fDateTime(activityFeedRow.paid_interaction_payment_at) +
      ' for $' +
      activityFeedRow.paid_interaction_payment_amount;
    severity = 'success';
    alertMsg = (
      <>
        Paid Interaction Approved for <b>${activityFeedRow.paid_interaction_payment_amount}</b>
      </>
    );
  } else if (activityFeedRow.paid_interaction_verification_submitted_at) {
    tooltipMsg =
      'Paid Interaction Verification Submitted ' +
      fDateTime(activityFeedRow.paid_interaction_verification_submitted_at);
    severity = 'warning';
    alertMsg = <>Paid Interaction Verification Submitted</>;
  } else {
    tooltipMsg = 'Paid Interaction Created ' + fDateTime(activityFeedRow.created_at);
    severity = 'info';
    alertMsg = <>Paid Interaction Created</>;
  }
  return (
    <Tooltip title={tooltipMsg} arrow>
      <Alert
        severity={severity}
        icon={icon}
        sx={{
          alignItems: 'center',
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: '6px',
          '.MuiAlert-icon': {
            marginRight: '6px',
          },
        }}
      >
        <Typography variant="caption">{alertMsg}</Typography>
      </Alert>
    </Tooltip>
  );
};

export default PaidInteractionAlert;
